import React, { createContext, useContext, useEffect, useState } from "react";
import { api, unwrap } from "@/api/client";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem("drms_user")); } catch { return null; }
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Rehydrate current user info if token exists
    const t = localStorage.getItem("drms_token");
    if (t && !user) {
      api.get("/auth/me").then(r => {
        const u = unwrap(r);
        setUser(u); localStorage.setItem("drms_user", JSON.stringify(u));
      }).catch(() => {});
    }
    // eslint-disable-next-line
  }, []);

  const login = async (email, password) => {
    setLoading(true);
    try {
      const r = await api.post("/auth/login", { email, password });
      const { token, user } = r.data.data;
      localStorage.setItem("drms_token", token);
      localStorage.setItem("drms_user", JSON.stringify(user));
      setUser(user);
      return user;
    } finally { setLoading(false); }
  };

  const logout = () => {
    localStorage.removeItem("drms_token");
    localStorage.removeItem("drms_user");
    setUser(null);
    window.location.href = "/login";
  };

  return <AuthCtx.Provider value={{ user, loading, login, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
